<template>
  <div>
    <slot :openModal="openModal"></slot>
    <b-modal size="lg" title="Cancel Subscription" hide-footer v-model="showModal">
      <div class="tw-p-4">
        <div v-if="step === 'ask'">
          <div class="tw-flex tw-flex-col tw-gap-6">

            <div class="tw-font-medium">Are you absolutely sure?</div>
            <div>By cancelling your subscription, you will lose access to any unused download credits when your current billing period expires.</div>

            <div class="tw-font-medium">Plan Details</div>
            <div>
              <div>{{ planName }}</div>
              <div>{{ availableTokens }} Unused credits</div>
            </div>

            <div class="tw-font-medium">Expiration</div>
            <div>{{ expirationDate }}</div>
          </div>

          <div class="tw-mt-12 tw-flex tw-justify-end tw-gap-4">
            <button class="btn btn-outline btn-rounded" @click="showModal = false">No, continue using pocstock</button>
            <button class="btn btn-danger btn-rounded" @click="step = 'reason'">Yes, cancel subscription</button>
          </div>
        </div>

        <div v-else-if="step === 'reason'">
          <div class="tw-flex tw-flex-col tw-gap-6">
            <div class="tw-font-medium">Why do you want to cancel your subscription?</div>

            <div class="tw-flex-col tw-flex tw-gap-2">
              <b-form-radio v-for="r in cancelReasons" :key="r" :value="r" v-model="reason" >
                {{ r }}
              </b-form-radio>
              <b-form-radio value="other" v-model="reason" >
                Other
              </b-form-radio>

              <b-form-textarea class="tw-mt-4" v-if="reason === 'other'" v-model="otherReason" placeholder="Tell us a brief reason about it"></b-form-textarea>
            </div>

            <div class="tw-mt-12 tw-flex tw-justify-end tw-gap-4">
              <button class="btn btn-outline btn-rounded" @click="showModal = false">Continue using pocstock</button>
              <button class="btn btn-danger btn-rounded" @click="handleCancelSubscription" :disabled="!validReason || loading">Confirm cancellation</button>
            </div>

          </div>
        </div>

        <div v-else-if="step === 'success'" class="tw-flex tw-flex-col tw-gap-8 tw-items-center tw-py-8">
          <div class="tw-text-2xl tw-font-semibold">
            Subscription cancelled successfully!
          </div>

          <i class="far fa-check-circle fa-4x text-primary"></i>

          <div class="tw-px-16 tw-text-center">
            Your subscription has been successfully cancelled. You still have full access to the service until subscription expires on {{ expirationDate }}.
          </div>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>

import GeneralMixins from "../../../mixins/GeneralMixins.js";
import {SubscriptionsApi} from "../../Api/SubscriptionsApi.js";

export default {
  mixins: [GeneralMixins],

  props: ['planName', 'availableTokens', 'expirationDate', 'cancelReasons', 'subscriptionId'],

  data() {
    return {
      showModal: false,
      step: "ask",
      reason: "",
      otherReason: "",
      loading: false,
    }
  },

  computed: {
    validReason() {
      return this.currentReason && this.currentReason !== ""
    },

    currentReason() {
      return this.reason === "other" ? this.otherReason : this.reason
    }
  },

  watch: {
    showModal(val) {
      if (!val && this.step === "success") {
        window.location.reload()
      }
    }
  },

  methods: {

    openModal() {
      this.showModal = true
    },

    async handleCancelSubscription() {
      this.loading = true
      try {
        await SubscriptionsApi.cancelSubscription(this.subscriptionId, this.currentReason)
        this.step = "success"
      } catch (e) {
        this.showErrorToast(this.getErrorMessages(e.body, true));
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style>
@tailwind base;
@tailwind components;
</style>